import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Button,
  FormControl,
  InputGroup,
  Container,
  Tooltip,
  OverlayTrigger,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "../../../components/formContainer";
import { listProductDetails, editProduct } from "../../../actions/product";
import { EDIT_PRODUCT_RESET } from "../../../actions/types";
import { createProduct } from "../../../actions/product";
import Message from "../../../components/message";
import Loader from "../../../components/loader";
import { Link } from "react-router-dom";
import { CREATE_PRODUCT_RESET } from "../../../actions/types";
import ShowImageForAdmin from "../../../components/showImageForAdmin";
import ShowEditableImages from "./showEditableImages";
import Editor from "../Editor";
import ShowSavedProductDetail from "../CreateNewProduct/showSavedProductDetail";
import ShowCreatedProductDetails from "../CreateNewProduct/showCreatedProductDetails";
import CarrierCompatibilityItems from "../CreateNewProduct/CarrierCompItems";

const NewProductScreen = ({ match, history }) => {
  const productId = match.params.id;

  // product Details Reducers
  const productDetails = useSelector((state) => state.productDetails);
  const {
    loading: productDetailLoading,
    product: productDetailsData,
    error: productDetailError,
  } = productDetails;

  // Edit product Reducers
  const productEdit = useSelector((state) => state.productEdit);
  const { loading: editLoading, success, error: editError } = productEdit;

  const successRef = useRef(null);

  useEffect(() => {
    if (success && successRef.current) {
      successRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      dispatch(listProductDetails(productId));
    }
  }, [success]);

  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [isFeatured, setIsFeatured] = useState(false);
  const [feature, setFeature] = useState("");
  const [description, setDescription] = useState("");
  const [style, setStyle] = useState("");
  const [rating, setRating] = useState("");
  const [material, setMaterial] = useState("");
  //
  const [chips, setChips] = useState([]);
  useEffect(() => {
    console.log("chips__editing", chips);
  }, [chips]);
  const [chipsArrForEdit, setChipsArrForEdit] = useState([]);
  //
  const [richTextContent, setRichTextContent] = useState("");

  const [capacity, setCapacity] = useState("");
  const [color, setColor] = useState("");
  const [stock, setStock] = useState();
  const [price, setPrice] = useState();
  const [discount, setDiscount] = useState();
  //
  const [imageArr, setImageArr] = useState([]);
  const [productDetailTemp, setProductDetailTemp] = useState();
  const [updateProductDetail, setUpdateProductDetail] = useState([]);
  const [createdProductDetail, setCreatedProductDetail] = useState([]);
  //
  const [deletingImageArr, setDeletingImageArr] = useState([]);

  const dispatch = useDispatch();

  const userAuth = useSelector((state) => state.userAuth);
  const { userInfo } = userAuth;

  const productCreate = useSelector((state) => state.productCreate);
  const { loading, error, product: productMessage } = productCreate;

  const nameRef = useRef(null);
  const categoryRef = useRef(null);
  const featureRef = useRef(null);
  const descriptionRef = useRef(null);
  const styleRef = useRef(null);
  const ratingRef = useRef(null);
  const materialRef = useRef(null);
  const capacityRef = useRef(null);
  const colorRef = useRef(null);
  const stockRef = useRef(null);
  const priceRef = useRef(null);
  const discountRef = useRef(null);
  //
  const productDetailRef = useRef(null);
  //
  const imageArrRef = useRef(null);

  const elementsRefs = {
    name: nameRef,
    category: categoryRef,
    feature: featureRef,
    description: descriptionRef,
    style: styleRef,
    rating: ratingRef,
    material: materialRef,
    capacity: capacityRef,
    color: colorRef,
    stock: stockRef,
    price: priceRef,
    discount: discountRef,
    productDetail: productDetailRef,
    //
    image: imageArrRef,
  };

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    }

    if (userInfo.role !== "admin") {
      history.push("/");
    }
    if (productMessage) {
      setTimeout(() => {
        dispatch({ type: CREATE_PRODUCT_RESET });
      }, 1500);
      //
    }
  }, [dispatch, history, match, userInfo, productMessage]);

  const [validationErrors, setValidationErrors] = useState({});

  const uploadImage = (base64EncodedImage) => {
    return base64EncodedImage;
  };

  const handleCreateProduct = (e) => {
    e.preventDefault();
    let errors = {};

    if (!name || name.trim() === "") {
      errors.name = "Product Name is required.";
    }

    if (!category || category.trim() === "") {
      errors.category = "Category is required.";
    }

    if (!feature || feature.trim() === "") {
      errors.feature = "Feature is required.";
    }

    if (!description || description.trim() === "") {
      errors.description = "Description is required.";
    }

    if (!style || style.trim() === "") {
      errors.style = "Style is required.";
    }

    if (!rating || rating < 0 || rating > 5) {
      errors.rating = "Rating must be between 0 and 5.";
    }

    if (
      updateProductDetail.length === 0 &&
      !productDetailTemp &&
      createdProductDetail.length === 0
    ) {
      errors.productDetail = "Product details are required";
    }

    if (!material || material.trim() === "") {
      errors.material = "Material information is required.";
    }

    const firstErrorField = Object.keys(errors)[0];
    const firstErrorRef = elementsRefs[firstErrorField];

    if (firstErrorRef && firstErrorRef.current) {
      const yOffset = -100;
      const y =
        firstErrorRef.current.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({ top: y - 150, behavior: "smooth" });
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors({ ...errors });
      return;
    }

    setValidationErrors({});

    //
    let updatedCapacity = [];

    if (updateProductDetail.length > 0) {
      updatedCapacity = [...updateProductDetail];
    }

    if (createdProductDetail.length > 0) {
      updatedCapacity = [...updatedCapacity, ...createdProductDetail];
    }

    const firstImages = updatedCapacity
      .flatMap((product) =>
        product.details.map((detail) =>
          detail.images.length > 0 ? detail.images[0].url : null
        )
      )
      .filter((img) => img !== null);

    const productCreationDetail = {
      productName: name,
      category,
      image: firstImages.slice(0, 3),
      isFeatured,
      feature,
      description,
      style,
      rating,
      material,
      carrierComp: chips,
      richText: richTextContent,
      capacity: updatedCapacity,
    };

    dispatch(editProduct(productCreationDetail, productId, deletingImageArr));
  };

  const handleCreateProductDetails = (e) => {
    e.preventDefault();

    let errors = {};

    if (productDetailTemp && productDetailTemp.capacity === "") {
      errors.productDetail = "Capacity is required";
    }

    if (productDetailTemp && productDetailTemp.details.length === 0) {
      errors.productDetail = "Product details are required";
    }

    if (productDetailTemp && productDetailTemp.details.length) {
      for (let index = 0; index < productDetailTemp.details.length; index++) {
        const detailObject = productDetailTemp.details[index];
        if (detailObject.images.length === 0)
          errors.productDetail =
            "At least an image is required along with product details";
      }
    }

    const firstErrorField = Object.keys(errors)[0];
    const firstErrorRef = elementsRefs[firstErrorField];

    if (firstErrorRef && firstErrorRef.current) {
      const yOffset = -100;
      const y =
        firstErrorRef.current.getBoundingClientRect().top +
        window.scrollY +
        yOffset;

      window.scrollTo({ top: y - 150, behavior: "smooth" });
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors({ ...errors });
      return;
    }

    setValidationErrors({});
    //

    setCreatedProductDetail((prev) => [...prev, productDetailTemp]);
    setProductDetailTemp();
    setCapacity("");
  };

  const handleSaveProductDetail = () => {
    setValidationErrors({});

    let errors = {};

    if (!imageArr || imageArr.length === 0) {
      errors.image = "At least an image is required along with product details";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors({ ...errors });
      return;
    }

    setValidationErrors({});

    const detailsObject = {
      color: color,
      quantity: stock ? Number(stock) : 0,
      price: Number(price),
      discount: discount ? Number(discount) : 0,
      images: imageArr.map((item) => uploadImage(item)),
    };

    let detailArr = [];
    if (!productDetailTemp) {
      detailArr = [detailsObject];
    } else {
      detailArr = [...productDetailTemp.details, detailsObject];
    }

    const productData = {
      capacity: capacity,
      details: detailArr,
    };

    setProductDetailTemp({ ...productData });

    setColor("");
    setStock("");
    setPrice("");
    setDiscount("");
    setImageArr([]);
  };

  // removing image-error upon saving the image
  useEffect(() => {
    let errors = {};

    if (imageArr || imageArr.length > 0) {
      errors.image = "";
    }

    if (capacity || capacity.trim() !== "") {
      errors.capacity = "";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors({ ...errors });
      return;
    }

    setValidationErrors({});
  }, [capacity, imageArr]);

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    previewFile(file);
    e.target.value = "";
  };

  const previewFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImageArr((prevImages) => [
        ...prevImages,
        { name: file.name, url: reader.result },
      ]);
    };
  };

  const handleAddNewImage = (capIndex, detailIndex, event) => {
    const file = event.target.files[0]; // Get selected file
    if (!file) return; // If no file, exit

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      const newImage = { name: file.name, url: reader.result }; // Create image object

      setUpdateProductDetail((prevDetails) =>
        prevDetails.map((capacityItem, cIndex) => {
          if (cIndex !== capIndex) return capacityItem; // Keep other capacities unchanged

          return {
            ...capacityItem,
            details: capacityItem.details.map((detailItem, dIndex) => {
              if (dIndex !== detailIndex) return detailItem; // Keep other details unchanged

              return {
                ...detailItem,
                images: [...detailItem.images, newImage], // Add new image object
              };
            }),
          };
        })
      );
    };

    event.target.value = ""; // Reset input
  };

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    } else {
      if (userInfo.role !== "admin") {
        history.push("/");
      }
      if (!productDetailsData) {
        dispatch(listProductDetails(productId));
      } else {
        if (productDetailsData._id !== productId || success) {
          dispatch(listProductDetails(productId));
        }
        setName(productDetailsData.productName);
        setCategory(productDetailsData.category);
        setIsFeatured(productDetailsData.isFeatured);
        setFeature(productDetailsData.feature);
        setDescription(productDetailsData.description);
        setStyle(productDetailsData.style);
        setRating(productDetailsData.rating);
        setMaterial(productDetailsData.material);
        //
        setRichTextContent(productDetailsData.richText);
        setUpdateProductDetail(productDetailsData.capacity);
        //
        setChipsArrForEdit(productDetailsData.carrierComp);
      }
    }
    if (success) {
      setTimeout(() => {
        dispatch({ type: EDIT_PRODUCT_RESET });
      }, 1500);
    }
  }, [
    dispatch,
    history,
    match,
    productId,
    productDetailsData,
    success,
    userInfo,
  ]);

  const UPLOADINGIMAGELIMIT = 6;

  // putting in updated data
  // Handle changes in capacity fields
  const handleCapacityChange = (index, field, value) => {
    const updatedDetails = [...updateProductDetail];
    updatedDetails[index][field] = value;
    setUpdateProductDetail(updatedDetails);
  };

  // Handle changes in nested details
  const handleDetailChange = (capIndex, detailIndex, field, value) => {
    const updatedDetails = [...updateProductDetail];
    updatedDetails[capIndex].details[detailIndex][field] = value;
    setUpdateProductDetail(updatedDetails);
  };

  // Handle image removal
  const handleRemoveImage = (capIndex, detailIndex, imgIndex) => {
    const updatedDetails = [...updateProductDetail];

    const image =
      updatedDetails[capIndex].details[detailIndex].images[imgIndex];
    if (image?.url && !image.url.startsWith("data:image")) {
      setDeletingImageArr((prev) => {
        if (!prev.includes(image.url)) {
          return [...prev, image.url];
        }
        return prev;
      });
    }

    updatedDetails[capIndex].details[detailIndex].images.splice(imgIndex, 1);
    setUpdateProductDetail(updatedDetails);
  };

  const handleRemoveCapacity = (capIndex) => {
    const selectedCapacity = updateProductDetail.find(
      (_, index) => index === capIndex
    );

    if (selectedCapacity) {
      const imageUrls =
        selectedCapacity?.details.flatMap(
          (detail) =>
            detail.images
              .map((image) => image.url)
              .filter((url) => !url.startsWith("data:image")) // Exclude base64 images
        ) || [];

      setDeletingImageArr((prev) => {
        const uniqueUrls = new Set([...prev, ...imageUrls]);
        return Array.from(uniqueUrls);
      });
    }

    setUpdateProductDetail((prevDetails) =>
      prevDetails.filter((_, index) => index !== capIndex)
    );
  };

  return (
    <Container>
      <Link to="/admin/productlist" className="btn btn-light my-3">
        Go Back
      </Link>
      {success && (
        <div ref={successRef}>
          <Message variant="success">{success}</Message>
        </div>
      )}
      <FormContainer>
        <h1>EDIT PRODUCT</h1>
        {error && <Message variant="danger">{error}</Message>}

        {loading ? (
          <Loader />
        ) : (
          <Form onSubmit={handleCreateProduct} autoComplete="on">
            <h5 className="mt-4">Product Name</h5>
            <div>
              <FormControl
                value={name || ""}
                placeholder="Product Name"
                onChange={(e) => setName(e.target.value)}
                ref={elementsRefs.name}
              />
              {validationErrors.name && (
                <small className="text-danger">{validationErrors.name}</small>
              )}
            </div>

            <h5 className="mt-4">Brand</h5>
            <div>
              <FormControl
                placeholder="Brand"
                onChange={(e) => setCategory(e.target.value)}
                value={category}
                ref={elementsRefs.category}
              />
              {validationErrors.category && (
                <small className="text-danger">
                  {validationErrors.category}
                </small>
              )}
            </div>

            <Form.Group className="py-2">
              <h5>is-Featured</h5>
              <Form.Select
                onChange={(e) => setIsFeatured(e.target.value)}
                value={isFeatured}
              >
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </Form.Select>
            </Form.Group>

            <>
              <h5 className="mt-4">Feature</h5>
              <div>
                <FormControl
                  placeholder="Feature"
                  onChange={(e) => setFeature(e.target.value)}
                  value={feature}
                  ref={elementsRefs.feature}
                />
                {validationErrors.feature && (
                  <small className="text-danger">
                    {validationErrors.feature}
                  </small>
                )}
              </div>

              <CarrierCompatibilityItems
                chipsArrForEdit={chipsArrForEdit}
                setChips={setChips}
              />

              <h5 className="mt-4">Description</h5>
              <div>
                <FormControl
                  placeholder="Description"
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                  ref={elementsRefs.description}
                />
                {validationErrors.description && (
                  <small className="text-danger">
                    {validationErrors.description}
                  </small>
                )}
              </div>

              <h5 className="mt-4">Style</h5>
              <div>
                <FormControl
                  placeholder="Style"
                  onChange={(e) => setStyle(e.target.value)}
                  value={style}
                  ref={elementsRefs.style}
                />
                {validationErrors.style && (
                  <small className="text-danger">
                    {validationErrors.style}
                  </small>
                )}
              </div>

              <h5 className="mt-4 mb-3">Rating</h5>
              <div>
                <InputGroup size="sm">
                  <FormControl
                    type="number"
                    placeholder="Rating"
                    value={rating}
                    onChange={(e) => setRating(e.target.value)}
                    max="5"
                    min="0"
                    ref={elementsRefs.rating}
                  />
                </InputGroup>
                {validationErrors.rating && (
                  <small className="text-danger">
                    {validationErrors.rating}
                  </small>
                )}
              </div>
            </>

            <div>
              {/* putting in the read data for updates */}
              <div
                style={{
                  marginTop: "30px",
                }}
              >
                <h4>Edit Product Capacity & Details</h4>

                {updateProductDetail.map((capacityItem, capIndex) => (
                  <div key={capIndex} className="border p-3 mb-3">
                    {/* <h5>Capacity: {capacityItem.capacity} GB</h5> */}
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Capacity: {capacityItem.capacity} GB</h5>
                      {updateProductDetail.length > 1 && (
                        <Button
                          variant="danger"
                          className="btn-sm"
                          onClick={() => handleRemoveCapacity(capIndex)}
                        >
                          <i className="fas fa-trash-alt" />
                        </Button>
                      )}
                    </div>

                    {/* Capacity Input */}
                    <Form.Group>
                      <Form.Label>Edit Capacity</Form.Label>
                      <Form.Control
                        type="text"
                        value={capacityItem.capacity}
                        onChange={(e) =>
                          handleCapacityChange(
                            capIndex,
                            "capacity",
                            e.target.value
                          )
                        }
                      />
                    </Form.Group>

                    {capacityItem.details.map((detailItem, detailIndex) => (
                      <div key={detailIndex} className="p-2 border mt-3">
                        <h6>Detail {detailIndex + 1}</h6>

                        {/* Display Details Row */}
                        <InputGroup className="my-2">
                          <InputGroup.Text>Details</InputGroup.Text>

                          {/* Color Input */}
                          <FormControl placeholder="Color" disabled />

                          {/* Price Input */}
                          <FormControl
                            type="number"
                            placeholder="Price in USD"
                            disabled
                          />

                          {/* Discount Input */}
                          <FormControl
                            type="number"
                            placeholder="Discount"
                            disabled
                          />

                          {/* Stock Input */}
                          <FormControl
                            type="number"
                            placeholder="Stock"
                            disabled
                          />
                        </InputGroup>

                        {/* Editable Details Row */}
                        <div className="mb-3">
                          <InputGroup className="my-2">
                            <InputGroup.Text>Details</InputGroup.Text>

                            {/* Color Input */}
                            <FormControl
                              placeholder="Color"
                              value={detailItem.color}
                              onChange={(e) =>
                                handleDetailChange(
                                  capIndex,
                                  detailIndex,
                                  "color",
                                  e.target.value
                                )
                              }
                            />

                            {/* Price Input */}
                            <FormControl
                              type="number"
                              placeholder="Price in USD"
                              value={detailItem.price}
                              onChange={(e) =>
                                handleDetailChange(
                                  capIndex,
                                  detailIndex,
                                  "price",
                                  e.target.value
                                )
                              }
                              min={0}
                            />

                            {/* Discount Input */}
                            <FormControl
                              type="number"
                              placeholder="Discount"
                              value={detailItem.discount}
                              onChange={(e) =>
                                handleDetailChange(
                                  capIndex,
                                  detailIndex,
                                  "discount",
                                  e.target.value
                                )
                              }
                              min={0}
                            />

                            {/* Stock Input */}
                            <FormControl
                              type="number"
                              placeholder="Stock"
                              value={detailItem.quantity}
                              onChange={(e) =>
                                handleDetailChange(
                                  capIndex,
                                  detailIndex,
                                  "quantity",
                                  e.target.value
                                )
                              }
                              min={0}
                            />

                            {/* Add Button */}
                            <Button
                              variant="primary"
                              className="btn-sm"
                              disabled={!detailItem.color || !detailItem.price}
                              style={{
                                backgroundColor: "#0d6efd",
                                color: "white",
                              }}
                            >
                              <i className="fas fa-plus" />
                            </Button>
                          </InputGroup>
                        </div>

                        {/* Show Images */}
                        <ShowEditableImages
                          source={detailItem.images}
                          handleRemoveImage={(imgIndex) =>
                            handleRemoveImage(capIndex, detailIndex, imgIndex)
                          }
                        />

                        <Form.Control
                          type="file"
                          onChange={(e) =>
                            handleAddNewImage(capIndex, detailIndex, e)
                          }
                          disabled={imageArr.length >= UPLOADINGIMAGELIMIT} // Disable if 2 or more images
                          style={
                            imageArr.length >= UPLOADINGIMAGELIMIT
                              ? { cursor: "not-allowed" }
                              : {}
                          }
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              {/*  */}

              <ShowCreatedProductDetails
                createdProductDetail={createdProductDetail}
                setCreatedProductDetail={setCreatedProductDetail}
              />
              <div>
                <h4 className="mt-5">Enter product capacity and details</h4>
                <FormControl
                  placeholder="Enter product capacity in GB"
                  value={capacity}
                  onChange={(e) => {
                    setCapacity(e.target.value);
                    if (productDetailTemp) {
                      setProductDetailTemp({
                        ...productDetailTemp,
                        capacity: e.target.value,
                      });
                    }
                  }}
                  ref={elementsRefs.productDetail}
                />
                {validationErrors.productDetail && (
                  <small className="text-danger">
                    {validationErrors.productDetail}
                  </small>
                )}
              </div>

              <ShowSavedProductDetail
                productDetailTemp={productDetailTemp}
                setProductDetailTemp={setProductDetailTemp}
              />

              <h5 className="mb-3 mt-4">Image</h5>
              <Form.Group>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      You can only upload up to {UPLOADINGIMAGELIMIT} images.
                    </Tooltip>
                  }
                  show={imageArr.length >= UPLOADINGIMAGELIMIT} // Tooltip shown only if there are 2 or more images
                >
                  <span>
                    <Form.Control
                      type="file"
                      onChange={handleFileInputChange}
                      disabled={imageArr.length >= UPLOADINGIMAGELIMIT} // Disable if 2 or more images
                      style={
                        imageArr.length >= UPLOADINGIMAGELIMIT
                          ? { cursor: "not-allowed" }
                          : {}
                      }
                    />
                    {validationErrors.image && (
                      <small className="text-danger">
                        {validationErrors.image}
                      </small>
                    )}
                  </span>
                </OverlayTrigger>
              </Form.Group>

              {imageArr.length > 0 && (
                <ShowImageForAdmin
                  create
                  source={imageArr}
                  handleRemoveImage={(index) => {
                    const updatedImages = [...imageArr];
                    updatedImages.splice(index, 1);
                    setImageArr(updatedImages);
                  }}
                  ref={elementsRefs.image}
                />
              )}

              {/* product detail selection */}
              <div className="mb-3">
                <InputGroup className="my-2">
                  <InputGroup.Text>Details</InputGroup.Text>
                  <FormControl
                    placeholder="Color"
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                    ref={elementsRefs.color}
                  />

                  {/* Price Input */}
                  <FormControl
                    type="number"
                    placeholder="Price in USD"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    min={0}
                    ref={elementsRefs.price}
                  />

                  {/* Discount Input */}
                  <FormControl
                    type="number"
                    placeholder="Discount"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                    min={0}
                    ref={elementsRefs.discount}
                  />

                  {/* Stock Input */}
                  <FormControl
                    type="number"
                    placeholder="Stock"
                    value={Number(stock)}
                    onChange={(e) => setStock(e.target.value)}
                    min={0}
                    ref={elementsRefs.stock}
                  />

                  {/* Add Button */}
                  <Button
                    variant="primary"
                    className="btn-sm"
                    onClick={handleSaveProductDetail}
                    disabled={!color || !price}
                    style={{
                      backgroundColor: "#0d6efd",
                      color: "white",
                    }}
                  >
                    <i className="fas fa-plus" />
                  </Button>
                </InputGroup>
              </div>

              <InputGroup size="sm" className="">
                <Button
                  className="btn-sm"
                  disabled={!productDetailTemp}
                  onClick={handleCreateProductDetails}
                >
                  Save Product
                </Button>
              </InputGroup>
            </div>

            <Editor content={richTextContent} setContent={setRichTextContent} />

            <>
              <h5 className="mt-4">Material</h5>
              <div>
                <FormControl
                  placeholder="Material"
                  onChange={(e) => setMaterial(e.target.value)}
                  value={material}
                  ref={elementsRefs.material}
                />
                {validationErrors.material && (
                  <small className="text-danger">
                    {validationErrors.material}
                  </small>
                )}
              </div>

              <div className="py-4">
                <Button
                  type="submit"
                  variant="primary"
                  style={{
                    backgroundColor: "#0d6efd",
                    color: "white",
                  }}
                >
                  {editLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Editing...
                    </>
                  ) : (
                    "UPDATE PRODUCT"
                  )}
                </Button>
              </div>
            </>
          </Form>
        )}
      </FormContainer>
    </Container>
  );
};

export default NewProductScreen;
